import { createContext } from 'react';

const Context = createContext({});

export const Provider = Context.Provider;

export default Context;
